module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.order) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("\n        Pedidos\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" Contrato " + _vm._s(_vm.order.contract) + "\n        "), _c('i', {
    staticClass: "icon-arrow-major-breadcrumb"
  }), _vm._v(" " + _vm._s(_vm.order.orderId) + "\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.order.status.statusId == 3),
      expression: "order.status.statusId == 3"
    }],
    staticClass: "alert alert-danger margin-b20",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('strong', [_vm._v("Ah, não! Seu pagamento não deu certo.")]), _vm._v(" Não se preocupe, você pode tentar reprocessar o pedido.\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-box margin-t20"
  }, [_c('h3', {
    staticClass: "bold"
  }, [_vm._v("Detalhes do Pedido")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 request-order"
  }, [_c('p'), _c('div', {
    staticClass: "request-status-label"
  }, [_vm._v("N° Pedido:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.order.orderId))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 request-date"
  }, [_c('p'), _c('div', {
    staticClass: "request-status-label"
  }, [_vm._v("Data da Solicitação:")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("date")(_vm.order.date)))]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 request-status"
  }, [_c('p'), _c('div', {
    staticClass: "request-status-label"
  }, [_vm._v("Status:")]), _vm._v(" "), _c('span', {
    class: _vm.statusPedido
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.order.status.name))]), _vm._v(" "), _c('p')])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-box margin-t20"
  }, [_c('h3', {
    staticClass: "bold"
  }, [_vm._v("Detalhes da Compra")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), [_c('div', {
    staticClass: "margin-20 resumo-table"
  }, [(_vm.order.products) ? _c('table', {
    staticClass: "table no-footer",
    attrs: {
      "role": "grid"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.order.products.product), function(product, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                    " + _vm._s(product.productName) + "\n                    "), (_vm.showVehiclesPlates(product)) ? _c('a', {
      staticClass: "label-link",
      on: {
        "click": function($event) {
          return _vm.toogleModal()
        }
      }
    }, [_vm._v("Visualizar Veículos")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-align-right"
    }, [_vm._v(" " + _vm._s(product.quantity))]), _vm._v(" "), _c('td', {
      staticClass: "request-unity-value-col"
    }, [_vm._v(" " + _vm._s(_vm._f("cents")(_vm.isDescont(product, product.valueUnit))))]), _vm._v(" "), _c('td', {
      staticClass: "text-align-right"
    }, [_vm._v(" " + _vm._s(_vm._f("cents")(_vm.isDescont(product, product.valueTotal))))])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "upper",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("total do pedido")]), _vm._v(" "), _c('td', {
    staticClass: "request-unity-value-col"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-align-right"
  }, [_vm._v(_vm._s(_vm._f("cents")(_vm.order.price)))])])], 2)]) : _vm._e()])], _vm._v(" "), (_vm.order.bankBillUrl) ? _c('div', {
    staticClass: "content-box margin-t20"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-align-right"
  }, [_c('div', [_c('a', {
    staticClass: "btn btn-default btn-sm bold",
    attrs: {
      "href": _vm.order.bankBillUrl,
      "target": "_blank"
    }
  }, [_vm._v("\n                    Visualizar o Boleto\n                  ")]), _vm._v(" "), _c('small', {
    staticStyle: {
      "padding": "5px 0"
    }
  }, [_vm._v("* Caso não consiga visualizar o boleto verifique seu bloqueador de popup.")])])])])]) : _vm._e(), _vm._v(" "), (_vm.canReprocess()) ? _c('div', {
    staticClass: "content-box margin-t20"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-right"
  }, [(_vm.order.type == 'PAYMENTPERUSE') ? _c('router-link', {
    staticClass: "btn btn-default btn-sm bold",
    attrs: {
      "to": {
        name: 'reprocess-orders',
        params: {
          contractId: _vm.order.contract
        }
      },
      "tag": "button",
      "type": "button",
      "name": "button",
      "disabled": _vm.reprocessed
    }
  }, [_vm._v("Reprocessar")]) : _c('button', {
    staticClass: "btn btn-default btn-sm bold",
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.reprocessed
    },
    on: {
      "click": function($event) {
        return _vm.showModalReprocessPayout()
      }
    }
  }, [_vm._v("Reprocessar")])], 1)])]) : _vm._e()], 2)])]), _vm._v(" "), (_vm.orderShipmentTracking) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-box margin-t20"
  }, [_c('h3', {
    staticClass: "bold"
  }, [_vm._v("Detalhes da Entrega")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, _vm._l((_vm.orderShipmentTracking), function(track, index) {
    return _c('div', {
      key: index,
      staticClass: "delivery-box border-right-gray"
    }, [_c('img', {
      staticClass: "icon-check",
      attrs: {
        "src": require("../../../assets/img/icon_circle_check_deliver.svg"),
        "alt": "Check",
        "width": "33px",
        "height": "33px"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-check"
    }, [_c('div', {
      staticClass: "info-title"
    }, [_vm._v(_vm._s(track.statusTracking.name))]), _vm._v(" "), _c('p', {
      staticClass: "no-margin"
    }, [_vm._v(_vm._s(_vm._f("dateTime")(track.dateOccurrence)))])]), _vm._v(" "), _c('small', [_vm._v(_vm._s(track.statusTracking.description))])])
  }), 0)]), _vm._v(" "), (_vm.order.shipment.shipmentService == 'PAC' && _vm.order.shipment.trackingNumber) ? _c('div', {
    staticClass: "margin-t20 margin-b10"
  }, [(!_vm.order.shipment.trackingNumber || _vm.order.shipment.trackingNumber == 'N/A') ? _c('div', [_vm._v("\n            O código de rastreio estará disponivel em breve.\n          ")]) : (_vm.order.shipment.carrier == 'CORREIOS') ? _c('form', {
    attrs: {
      "method": "GET",
      "action": "https://www.websro.com.br/rastreamento-correios.php?",
      "target": "popup",
      "onsubmit": "window.open('', 'popup', 'width=800,height=400');"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "P_COD_UNI",
      "rows": "1",
      "size": "14",
      "wrap": "VIRTUAL"
    },
    domProps: {
      "value": _vm.order.shipment.trackingNumber
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inline track-order"
  }, [_vm._v("Código de Rastreamento: "), _c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.order.shipment.trackingNumber))]), _vm._v(" - " + _vm._s(_vm.order.shipment.carrier))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "target": "_blank"
    }
  }, [_vm._v("Rastrear Entrega")])]) : (_vm.order.shipment.carrier == 'JADLOG') ? _c('form', {
    attrs: {
      "method": "POST",
      "action": "https://www.jadlog.com.br/siteDpd/tracking.jad",
      "target": "popup",
      "onsubmit": "window.open('', 'popup', 'width=800,height=400');"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cte"
    },
    domProps: {
      "value": _vm.order.shipment.trackingNumber
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "lang",
      "value": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "inline track-order"
  }, [_vm._v("Código de Rastreamento: "), _c('b', {
    staticClass: "upper"
  }, [_vm._v(_vm._s(_vm.order.shipment.trackingNumber))]), _vm._v(" - " + _vm._s(_vm.order.shipment.carrier))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "submit",
      "target": "_blank"
    }
  }, [_vm._v("Rastrear Entrega")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.order.shipment.shipmentService == 'PAC') ? [_c('p', [_vm._v("Endereço da entrega:")]), _vm._v(" "), _c('div', {
    staticClass: "content-box background-solid"
  }, [_c('p', [_vm._v(_vm._s(_vm.address))])])] : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('router-link', {
    staticClass: "btn btn-back margin-t20",
    attrs: {
      "to": {
        name: 'requests'
      },
      "tag": "button"
    }
  }, [_c('i', {
    staticClass: "icon-circle-left align-icon-left"
  }), _vm._v(" Voltar\n      ")])], 1)]), _vm._v(" "), (_vm.showVehicle) ? _c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block",
      "background": "rgba(230, 230, 230, 0.8)"
    },
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header modal-info"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showVehicle = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Visualizar Veículos")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "bold-600 text-center"
  }, [_vm._v("Placa dos Veículos:")]), _vm._v(" "), _c('div', {
    staticClass: "cell-plate"
  }, _vm._l((_vm.listVehicles), function(vehicle, index) {
    return _c('div', {
      key: index
    }, [_vm._v("\n              " + _vm._s(vehicle.plate) + "\n            ")])
  }), 0)])])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('reprocess', {
    attrs: {
      "orderId": _vm.order.orderId,
      "contractId": _vm.order.contract
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "reprocessConfirmed": _vm.goToOrders,
      "Reprocessar": function($event) {
        _vm.reprocessed = true
      }
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("Descrição")]), _vm._v(" "), _c('th', {
    staticClass: "request-amount-col"
  }), _vm._v(" "), _c('th', {
    staticClass: "request-unity-value-col"
  }, [_vm._v("Valor Unitário")]), _vm._v(" "), _c('th', {
    staticClass: "text-align-right",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Valor Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticClass: "bold"
  }, [_vm._v("Boleto Bancário")])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-3792da5a!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/request/request-detail.vue
// module id = 2095
// module chunks = 1